export default "__VITE_PUBLIC_ASSET__a84f47c1__"